import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

type StyledProps = {
  image_type?: string;
};

export const StyledImage = styled.img<StyledProps>`
  object-fit: contain;
  width: 100%;
  border-radius: 16px;
  margin-top: ${({ image_type }) => image_type === "commerical" && "45px"};
`;
export const StyledCaption = styled.div`
  color: ${({ theme }) => theme.default.color.text.darkGrey};
  font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-style: normal;
  font-weight: 400;
  text-align: left;
  line-height: 16px;
  font-size: 12px !important;
  p {
    margin: 8px 0 0 0;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledCredit = styled.span`
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  margin: 0;
  font-size: 15px !important;
  font-style: italic;
  font-weight: 400;
  letter-spacing: 0em;
  // white-space: nowrap;
  text-align: left;
  @media (max-width: ${defaultBreakpoints.medium}) {
    line-height: 15px !important;
  }
`;
